import PageHeader from "@/components/PageHeader";
import Showroom from "@/components/Showroom";

export default function VespaPage() {
  return (
    <>
      <PageHeader
        overline="Vespa Modelle"
        title="Der"
        accent="Showroom."
        subtitle="GTS Super, Primavera, Sprint, das limitierte 946 Anniversario — italienische Ikonen mit Garantie."
      />
      <Showroom />
    </>
  );
}
